import React, { useState } from 'react';

import styles from './CollapsibleSection.module.css';
import { CollapsibleSectionProps } from './CollapsibleSection.types';

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  id,
  ariaLabelledBy,
  title,
  isCollapsible = true,
  defaultOpen = true,
  isKnownIssues = false,
  className = '',
  titleClassName = '',
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const cardClasses = `${styles.sectionCard} ${isKnownIssues ? styles.knownIssuesCard : ''} ${
    isCollapsible ? styles.collapsibleCard : ''
  } ${className}`.trim();

  const titleClasses = `${styles.sectionTitle} ${isKnownIssues ? styles.knownIssuesTitle : ''} ${
    isCollapsible ? styles.collapsibleTitle : ''
  } ${titleClassName}`.trim();

  if (!isCollapsible) {
    return (
      <section className={cardClasses} id={id} aria-labelledby={ariaLabelledBy}>
        <div className={titleClasses}>{title}</div>
        <div className={`${styles.sectionBody} ${styles.staticBody}`}>{children}</div>
      </section>
    );
  }

  return (
    <section className={cardClasses} id={id} aria-labelledby={ariaLabelledBy}>
      <button
        type="button"
        className={styles.collapsibleHeader}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <div className={titleClasses}>{title}</div>
        <svg
          className={`${styles.chevronIcon} ${isOpen ? styles.chevronIconOpen : ''}`}
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        </svg>
      </button>
      {isOpen && <div className={styles.sectionBody}>{children}</div>}
    </section>
  );
};
